const clickOriginalImageCommand = (popup, editor, cmd, param) => {
  const selector = param
    ? `.teo-image-original-buttons .fr-command[data-cmd="${cmd}"][data-param1="${param}"]`
    : `.teo-image-original-buttons .fr-command[data-cmd="${cmd}"]`;

  const original = popup.querySelector(selector);

  if (original) {
    original.dispatchEvent(
      new MouseEvent('mousedown', {
        bubbles: true,
        cancelable: true,
        view: window,
      })
    );
    original.dispatchEvent(
      new MouseEvent('mouseup', {
        bubbles: true,
        cancelable: true,
        view: window,
      })
    );
    original.dispatchEvent(
      new MouseEvent('click', { bubbles: true, cancelable: true, view: window })
    );

    return true;
  }

  editor.selection?.restore?.();

  if (param !== undefined) {
    editor.commands.exec(cmd, param);
  } else {
    editor.commands.exec(cmd);
  }

  return true;
};

const updateImageSubmenuActiveState = (editor, popup) => {
  const $img = editor?.image?.get?.();
  if (!$img?.length) return;

  const img = $img.get(0);
  const style = window.getComputedStyle(img);

  const display = style.display;
  const floatValue = style.float;
  const textAlign = style.textAlign;
  const marginLeft = style.marginLeft;
  const marginRight = style.marginRight;

  let activeAlign = '';

  if (floatValue === 'left' || textAlign === 'left') {
    activeAlign = 'left';
  } else if (floatValue === 'right' || textAlign === 'right') {
    activeAlign = 'right';
  } else if (
    textAlign === 'center' ||
    (display === 'block' && marginLeft === 'auto' && marginRight === 'auto')
  ) {
    activeAlign = 'center';
  }

  let activeDisplay = '';

  if (floatValue === 'left' || floatValue === 'right') {
    activeDisplay = 'inline';
  } else if (display === 'inline' || display === 'inline-block') {
    activeDisplay = 'inline';
  } else if (display === 'block') {
    activeDisplay = 'block';
  }

  popup.querySelectorAll('[data-teo-image-param]').forEach((btn) => {
    const cmd = btn.getAttribute('data-teo-image-cmd');
    const param = btn.getAttribute('data-teo-image-param');

    btn.classList.remove('teo-image-settings-item_active');
    btn.querySelector('.teo-active-check')?.remove();

    const isActive =
      (cmd === 'imageAlign' && param === activeAlign) ||
      (cmd === 'imageDisplay' && param === activeDisplay) ||
      (cmd === 'imageStyle' && img.classList.contains(param));

    if (isActive) {
      btn.classList.add('teo-image-settings-item_active');
      btn.insertAdjacentHTML(
        'beforeend',
        `
                <span class="teo-active-check ml-auto">
                    <i class="far fa-check ml-auto text-[17px]"></i>
                </span>
                `
      );
    }
  });
};

const positionPopupAtTargetTopLeft = (popup, target) => {
  if (!popup || !target) return;

  const rect = target.getBoundingClientRect();

  popup.style.setProperty('position', 'absolute', 'important');
  popup.style.setProperty(
    'left',
    `${rect.left + window.scrollX}px`,
    'important'
  );
  popup.style.setProperty('top', `${rect.top + window.scrollY}px`, 'important');
  popup.style.setProperty('transform', 'none', 'important');
};

export const updateImagePopupDesign = (editor, isEdit) => {
  const t = window.i18n.t;

  const imageMenuItems = [
    {
      label: t('widgets.toolbar_button.image_settings.replace_image'),
      icon: '<i class="far fa-exchange-alt text-[17px]"></i>',
      cmd: 'imageReplace',
    },
    {
      label: t('widgets.toolbar_button.image_settings.image_alignment'),
      icon: '<i class="far fa-align-left text-[17px]"></i>',
      cmd: 'imageAlign',
      arrow: true,
    },
    {
      label: t('widgets.toolbar_button.image_settings.text_wrapping'),
      icon: '<i class="far fa-indent text-[17px]"></i>',
      cmd: 'imageDisplay',
      arrow: true,
    },
    {
      label: t('widgets.toolbar_button.image_settings.image_caption'),
      icon: '<img src="/images/icons/image_caption.svg" class="!w-5" />',
      cmd: 'imageCaption',
    },
    {
      label: t('widgets.toolbar_button.image_settings.resize'),
      icon: '<i class="far fa-expand-alt text-[17px]"></i>',
      cmd: 'imageSize',
      arrow: true,
    },
    {
      label: t('widgets.toolbar_button.image_settings.link_URL'),
      icon: '<i class="far fa-link text-[17px]"></i>',
      cmd: 'imageLink',
      arrow: true,
    },
    {
      label: isEdit
        ? t('widgets.toolbar_button.image_settings.edit_to_library')
        : t('widgets.toolbar_button.image_settings.add_to_library'),
      icon: '<i class="fal fa-books text-[17px] !text-[#fdbe06]"></i>',
      cmd: 'addImageLibrary',
      arrow: true,
    },
    {
      label: t('widgets.toolbar_button.image_settings.image_styling'),
      icon: '<img src="/images/icons/color-wand.svg" class="!w-5" />',
      cmd: 'imageStyle',
      arrow: true,
    },
    {
      label: t('widgets.toolbar_button.image_settings.alt_text'),
      icon: '<img src="/images/icons/alt_text.svg" class="!w-5" />',
      cmd: 'imageAlt',
      arrow: true,
    },
    {
      label: t('widgets.toolbar_button.image_settings.advanced_editing'),
      icon: '<i class="far fa-sliders-h text-[17px]"></i>',
      cmd: 'imageTUI',
      arrow: true,
    },
    {
      label: t('widgets.toolbar_button.image_settings.delete_image'),
      icon: '<img src="/images/icons/trash_icon_red.svg" class="!w-4" />',
      cmd: 'imageRemove',
      danger: true,
    },
  ];
  const submenus = {
    imageAlign: [
      {
        icon: '<i class="far fa-align-left text-[17px]"></i>',
        label: t('widgets.toolbar_button.left_align'),
        param: 'left',
      },
      {
        icon: '<i class="far fa-align-right text-[17px]"></i>',
        label: t('widgets.toolbar_button.right_align'),
        param: 'right',
      },
      {
        icon: '<i class="far fa-align-center text-[17px]"></i>',
        label: t('widgets.toolbar_button.middle_align'),
        param: 'center',
      },
    ],
    imageDisplay: [
      {
        label: t('widgets.toolbar_button.image_settings.inline'),
        icon: '<i class="far fa-indent text-[17px]"></i>',
        param: 'inline',
      },
      {
        label: t('widgets.toolbar_button.image_settings.break_text'),
        icon: '<img src="/images/icons/insert_media.svg" class="!w-5" />',
        param: 'block',
      },
    ],
    imageStyle: [
      {
        label: t('widgets.toolbar_button.image_settings.rounded'),
        icon: '',
        param: 'fr-rounded',
      },
      {
        label: t('widgets.toolbar_button.image_settings.bordered'),
        icon: '',
        param: 'fr-bordered',
      },
      {
        label: t('widgets.toolbar_button.image_settings.shadow'),
        icon: '',
        param: 'fr-shadow',
      },
    ],
  };
  const popup = editor?.popups?.get?.('image.edit')?.get?.(0);
  if (!popup || popup.dataset.teoImagePopupReady === 'true') return;

  popup.dataset.teoImagePopupReady = 'true';
  popup.classList.add('teo-image-popup');

  const $img = editor?.image?.get?.();

  if ($img?.length) {
    positionPopupAtTargetTopLeft(popup, $img.get(0));
  }

  const buttons = popup.querySelector('.fr-buttons');
  if (!buttons) return;

  const oldButtonsHtml = buttons.innerHTML;

  buttons.innerHTML = `
    <div class="teo-image-settings-menu">
      ${imageMenuItems
        .map((item) => {
          const submenu = submenus[item.cmd];

          return `
            <div class="teo-image-settings-row">
              <button
                type="button"
                class="teo-image-settings-item ${
                  item.danger ? 'teo-image-settings-item_danger' : ''
                }"
                data-teo-image-cmd="${item.cmd}"
              >
                <span class="teo-image-settings-icon">${item.icon}</span>
                <span class="teo-image-settings-label">${item.label}</span>
                ${
                  item.arrow
                    ? '<i class="far fa-chevron-right text-grey-03 ml-auto"></i>'
                    : ''
                }
              </button>

              ${
                submenu
                  ? `
                    <div class="teo-image-submenu-inline">
                      <div class="teo-image-submenu-list">
                        ${submenu
                          .map(
                            (sub) => `
                              <button
                                type="button"
                                class="teo-image-settings-item"
                                data-teo-image-cmd="${item.cmd}"
                                data-teo-image-param="${sub.param}"
                              >
                                <span class="teo-image-submenu-icon">${sub.icon}</span>
                                <span class="teo-image-submenu-label">${sub.label}</span>
                              </button>
                            `
                          )
                          .join('')}
                      </div>
                    </div>
                  `
                  : ''
              }
            </div>
          `;
        })
        .join('')}
    </div>

    <div class="teo-image-original-buttons" style="display:none;">
      ${oldButtonsHtml}
    </div>
  `;

  updateImageSubmenuActiveState(editor, popup);

  popup.querySelectorAll('[data-teo-image-cmd]').forEach((btn) => {
    btn.addEventListener('mousedown', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const cmd = btn.getAttribute('data-teo-image-cmd');
      const param = btn.getAttribute('data-teo-image-param');

      if (!cmd) return;

      if (submenus[cmd] && !param) return;

      if (cmd === 'addImageLibrary') {
        editor.openImageLibraryForSelectedImage?.();
        return;
      }

      clickOriginalImageCommand(popup, editor, cmd, param || undefined);

      setTimeout(() => {
        updateImageSubmenuActiveState(editor, popup);
        editor.popups.hide('image.edit');
      }, 0);
    });
  });
};
